var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_3166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.3945V19.3945C16.5 18.3337 16.0786 17.3163 15.3284 16.5661C14.5783 15.816 13.5609 15.3945 12.5 15.3945H5.5C4.43913 15.3945 3.42172 15.816 2.67157 16.5661C1.92143 17.3163 1.5 18.3337 1.5 19.3945V21.3945",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.3945C11.2091 11.3945 13 9.60367 13 7.39453C13 5.18539 11.2091 3.39453 9 3.39453C6.79086 3.39453 5 5.18539 5 7.39453C5 9.60367 6.79086 11.3945 9 11.3945Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.3945L19.5 13.3945L23.5 9.39453",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_3166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.394531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.f7c61a6ef22b322daa040c39a1918e9c.svg";
export { ForwardRef as ReactComponent };